import request from '@/fetch/index'

// 获取贷款信息列表
export function getLoanList({ pageNo, pageSize }) {
  return request({
    url: '/api/loan/apply/app/',
    method: 'GET',
    params: {
      pageNo,
      pageSize
    }
  })
}

// 获取贷款详细信息列表
export function getLoanDetail({ id }) {
  return request({
    url: `/api/loan/apply/app/${id}`,
    method: 'GET'
  })
}

// 重复订单检查
export function repeatOrderCheck(params) {
  return request({
    url: '/api/loan/apply/app/repeat',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}

// 提交订单
export function submitOrder(params) {
  return request({
    // url: '/apply/app/submit',
    url: '/api/loan/apply/app/submit',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}

// 5笔订单限制
export function getIsApplyLimit(uniscid) {
  return request({
    url: `/api/loan/apply/bank/isApplyLimit/${uniscid}`,
    method: 'GET'
  })
}

/**
 * 获取草稿订单数量
 */
export function getPendingOrderCount() {
  return request({
    url: '/api/loan/apply/h5/waitingHandle/count',
    method: 'GET'
  })
}

/**
 * 草稿订单删除
 * @param {*} id 订单在库中的递增值
 */
export function deleteDraftOrder({ id }) {
  return request({
    url: '/api/loan/apply/h5/draft/delete',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: { id }
  })
}

/**
 * 按需获取委托书授权书图片信息
 * @param {fileid} 文件id
 * @param {authorizedApplyId} 授权表id
 */
export function getAuthImageById (params) {
  return request({
    url: '/api/loan/apply/authorizedFileInfo',
    method: 'GET',
    params
  })
}

/**
 * 按需获取其他材料
 * @param {address} 文件地址
 * @param {fileGroupNo} 文件组编号
 */
export function getApplyFileInfoImageById (params) {
  return request({
    url: '/api/loan/apply/applyFileInfo',
    method: 'GET',
    params
  })
}

/**
 * 用户是否存在相同产品的在途订单，不存在返回0  by 3.10.0
 * @param {*} productId
 */
export function getIntransitApplyCount (productId) {
  return request({
    url: `/api/loan/apply/h5/getIntransitApplyCount/${productId}`,
    method: 'GET'
  })
}

/**
 * 授权/委托历史记录
 * @param {string} id 授权、委托表 id
 */
export function authAndEntrustHistoryFile (params) {
  return request({
    url: '/api/loan/systemUser/historyAuthorizedInfo',
    method: 'GET',
    params
  })
}
